import React from 'react'
import DataTable, { TableProps, TableStyles } from 'react-data-table-component'
import { CustomSortIcon } from './CustomSortIcon'
import { CustomPaginationComponent } from './CustomPaginationComponent'
import { Spinner } from 'react-bootstrap'
import { DEFAULT_PAGE_SIZE } from '../../common/constants'

export const ZocksDataTable = <T extends object>(props: TableProps<T>) => {
  const { customStyles: propsCustomStyles, ...restProps } = { ...props }
  const customStyles: TableStyles = {
    responsiveWrapper: {
      style: {
        overflow: 'unset',
        '@media(max-width: 769px)': {
          width: '756px',
        },
      },
    },
    tableWrapper: {
      style: {
        display: 'flex',
        flexDirection: 'column',
      },
    },
    headCells: {
      style: {
        span: {
          paddingLeft: '0.5rem',
        },
        fontSize: '0.75rem',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '1.125rem' /* 150% */,
        textTransform: 'uppercase',

        color: '#212529',
      },
    },
    headRow: {
      style: { borderBottomColor: '#E9ECEF !important' },
    },
    rows: {
      style: {
        paddingTop: '1rem',
        paddingBottom: '1rem',
        borderBottomColor: '#E9ECEF !important',
      },
      highlightOnHoverStyle: {
        backgroundColor: '#F8F9FA',
        borderBottomColor: '#F8F9FA !important',
      },
    },
  }

  return (
    <DataTable
      progressComponent={<Spinner />}
      customStyles={{ ...customStyles, ...propsCustomStyles }}
      sortIcon={CustomSortIcon}
      paginationPerPage={DEFAULT_PAGE_SIZE}
      paginationComponent={CustomPaginationComponent}
      highlightOnHover={true}
      {...restProps}
    />
  )
}
